import _, { slice } from "lodash"
import { EventEmitter } from "./event_emitter"
import { generateId } from "./utils"




export class ConditionExpression extends EventEmitter {
    public accessType: string
    public id: string
    public expressions: any
    public expressionsStr: any
    private api: any
    constructor({ accessType, expressions, id }: any) {
        super()
        this.accessType = accessType
        this.id = id || generateId()
        if (expressions) {
            this.expressions = expressions
        }

    }

    static load(condition: any) {
        return new ConditionExpression(condition)
    }
    /**
     * init
     */
    public async init() {
        return this.check()
    }
    /**
     * setApi
api:any     */
    public setApi(api: any) {
        this.api = api
    }
    /**
     * check
     */
    public async check() {
        const { error, data } = await this.api.check(this.expressions)
        if (error) {
            throw error;
        }
        this.expressionsStr = data
        return data
    }
    /**
     * walk
     */
    public walk(fn: any, expression?: any) {
        if (!expression) {
            expression = this.expressions
        }
        // const out = []
        const typeOf = expression.typeof
        switch (typeOf) {
            case "binary":
                const isGroup = expression.parens
                const operator = expression.operatorStr
                switch (operator) {
                    case "OR" || "AND":
                        //walk left
                        {
                            if (expression.left) {
                                const left: any = this.walk(fn, expression.left)
                            }
                            //walk right
                            if (expression.right) {
                                const right: any = this.walk(fn, expression.right)
                            }
                        }

                        break;

                    default:
                        {
                            const left: any = this.walk(fn, expression.left)
                            //walk right
                            const right: any = this.walk(fn, expression.right)
                            fn(left, right, expression.operatorStr, expression.parens)
                            return expression
                        }
                        break;
                }
                // console.log(operator);
                // console.log(isGroup);


                if (!isGroup) {
                    // out.push(fn(left, right, expression.operatorStr, expression.parens))
                    // fn(left, right, expression.operatorStr, expression.parens)
                }
                // fn(left, right, expression.operatorStr, expression.parens)

                break;
            case "reference":
                return expression.reference
            default:
                break;
        }
        // return out
    }
    /**
     * insert
     */
    public insert(path: any) {
        console.log(path, _.get(this.expressions, path));
        const node = _.get(this.expressions, path)

        if (node) {
            _.set(this.expressions, path, {
                left: node,
                operator: 17,
                operatorStr: "AND",
                parens: false,
                typeof: "binary",
                right:
                {
                    "left": {
                        "reference": "new insert",
                        "typeof": "reference"
                    },
                    "operator": 7,
                    "operatorStr": "==",
                    "parens": false,
                    "right": {
                        "reference": "new insert",
                        "typeof": "reference"
                    },
                    "typeof": "binary"
                }
            })
        }

    }
    /**
   * insert
   */
    public insertSub(path: any) {
        if (!path || !path.length) {
            return this.insertRoot(path)
        }
        console.log(path, _.get(this.expressions, path));
        const node = _.get(this.expressions, path)

        if (node) {
            _.set(this.expressions, path, {
                left: node,
                operator: 17,
                operatorStr: "AND",
                parens: true,
                typeof: "binary",
                right:
                {
                    "left": {
                        "reference": "new insert",
                        "typeof": "reference"
                    },
                    "operator": 7,
                    "operatorStr": "==",
                    "parens": false,
                    "right": {
                        "reference": "new insert",
                        "typeof": "reference"
                    },
                    "typeof": "binary"
                }
            })
        }

    }
    /**
     * remove
     */
    public remove(path: any) {
        debugger
        if (!path || !path.length) {
            this.expressions = undefined
            return
        }
        const lastPath = _.last(path)
        const expr = _.get(this.expressions, path)
        const exprParent = _.get(this.expressions, path.slice(0, path.length - 1)) || this.expressions
        const parenPath = path.slice(0, path.length - 1)
        function set(expressions: any, parenPath: any, node: any) {
            if (parenPath && parenPath.length) {
                _.set(expressions, parenPath, node)
            } else {
                expressions = node
            }
            return expressions
        }
        switch (lastPath) {
            case "left":
                this.expressions = set(this.expressions, parenPath, exprParent.right)
                break;
            case "right":
                this.expressions = set(this.expressions, parenPath, exprParent.left)
                break;
            default:
                break;
        }

        return false


    }
    private emptyExpressionNode() {
        return {
            "left": {
                "reference": "new insert",
                "typeof": "reference"
            },
            "operator": 7,
            "operatorStr": "==",
            "parens": false,
            "right": {
                "reference": "new insert",
                "typeof": "reference"
            },
            "typeof": "binary"
        }
    }
    public insertRoot(path: any) {
        if (!this.expressions) {
            this.expressions = this.emptyExpressionNode()
            return
        }
        const { left, right, operatorStr } = this.expressions
        switch (operatorStr) {
            case "AND" || "OR" || "NOT":
                if (right) {
                    this.expressions.right = {
                        left: right,
                        operator: 17,
                        operatorStr: "AND",
                        parens: false,
                        typeof: "binary",
                        right:
                        {
                            "left": {
                                "reference": "new insert",
                                "typeof": "reference"
                            },
                            "operator": 7,
                            "operatorStr": "==",
                            "parens": false,
                            "right": {
                                "reference": "new insert",
                                "typeof": "reference"
                            },
                            "typeof": "binary"
                        }
                    }
                }
                break;

            default:
                this.expressions = {
                    left: this.expressions,
                    operatorStr: "AND",
                    parens: false,
                    typeof: "binary",
                    right: {
                        "left": {
                            "reference": "new insert",
                            "typeof": "reference"
                        },
                        "operator": 7,
                        "operatorStr": "==",
                        "parens": false,
                        "right": {
                            "reference": "new insert",
                            "typeof": "reference"
                        },
                        "typeof": "binary"
                    }
                }
                break;
        }


    }
    static typeOfKey: any = {
        "string": "literal",
        "bool": "bool",
        "identifier": "ident",
        "reference": "reference",
        "number": "number"
    }
    /**
     * update
     */
    public update(path: any, expr: any) {
        const oExpr = _.get(this.expressions, path) || this.expressions
        if (!oExpr) {
            return
        }
        if (expr.left) {
            oExpr.left[oExpr.left.typeof] = expr.left
        }
        if (expr.right) {
            let typeOf = ""
            switch (getType(expr.right) as string) {
                // case "isNumber":
                //     break;
                case "isString":
                    typeOf = "string"
                    break;
                case "isBoolean":
                    typeOf = "bool"
                    break;
                case "isIdentifier":
                    typeOf = "identifier"

                    break;
                case "isReference":
                    typeOf = "reference"
                    break;
                case "isNumber":
                    typeOf = "number"
                    break;
                case "isNull":
                    typeOf = "null"
                    break;
                default:
                    break;
            }
            const typeOfKey = ConditionExpression.typeOfKey[typeOf]
            const lastTypeOfKey = ConditionExpression.typeOfKey[oExpr.right["typeof"]]

            // oExpr.right[lastTypeOfKey] = undefined
            // delete oExpr.right[lastTypeOfKey]

            // oExpr.right["typeof"] = typeOf
            // if (typeOf == "string") {
            //     expr.right = _.trim(expr.right)
            //     expr.right = expr.right.slice(1)
            //     expr.right = expr.right.slice(0, expr.right.length - 1)
            // }
            // if (typeOf == "number") {
            //     expr.right = +expr.right
            //     if (_.isInteger(expr.right)) {
            //         oExpr.right = {
            //             "base": 10,
            //             "typeof": "number",
            //             "isint": true,
            //             "isfloat": false,
            //             "int64": expr.right
            //         }
            //     } else {
            //         oExpr.right = {
            //             "base": 10,
            //             "typeof": "number",
            //             "isfloat": true,
            //             "isint": false,
            //             "float64": expr.right
            //         }
            //     }
            //     return
            // }
            oExpr.right = formatValue(typeOf, expr.right)
            // oExpr.right[typeOfKey] = expr.right
        }
        if (expr.operatorStr) {
            oExpr.operatorStr = expr.operatorStr
        }
        _.set(this.expressions, path, { ...oExpr })
    }
    public updateValue(path: any, value: any) {
        _.set(this.expressions, path, value)
    }
    private current: any
    static traversal(expression: any, list: any, path?: any) {
        if (expression) {
            path = path || []
            switch (expression.operatorStr) {
                case "==":
                case ":":
                case "!=":
                case "!:":
                    list.push({ ...expression, path })
                    break;

                default:
                    if (expression.parens) {
                        const groups: any = []
                        this.traversal(expression.left, groups, [...path, "left"])
                        if (expression.right) {
                            groups.push({ operatorStr: expression.operatorStr, path: [...path, "operatorStr"] })
                            this.traversal(expression.right, groups, [...path, "right"])
                        }
                        list.push(groups)
                    } else {
                        this.traversal(expression.left, list, [...path, "left"])
                        if (expression.right) {
                            list.push({ operatorStr: expression.operatorStr, path: [...path, "operatorStr"] })
                            this.traversal(expression.right, list, [...path, "right"])
                        }
                    }

                    break;
            }

        }
    }
    static clone(condition: any) {
        return new ConditionExpression(condition)
    }
    public parser() {
        if (!this.expressions) {
            return undefined
        }
        const list: any = []
        ConditionExpression.traversal(this.expressions, list)
        return list
        // if (!this.current) {
        //     this.current = ["left"]
        //     return _.get(this.expressions, this.current)
        // }
        // if (_.last(this.current) == "left") {
        //     this.current.push("right")
        //     return _.get(this.expressions, this.current)
        // }
    }
    static demo() {
        return new ConditionExpression({
            accessType: "", expression: {
                "left": {
                    "left": {
                        "reference": "IsOA",
                        "typeof": "reference"
                    },
                    "operator": 7,
                    "operatorStr": "==",
                    "parens": false,
                    "right": {
                        "reference": "true",
                        "typeof": "reference"
                    },
                    "typeof": "binary"
                },
                "operator": 17,
                "operatorStr": "AND",
                "parens": false,
                "right": {
                    "left": {
                        "left": {
                            "reference": "PeriodicalClassCode",
                            "typeof": "reference"
                        },
                        "operator": 7,
                        "operatorStr": "==",
                        "parens": false,
                        "right": {
                            "reference": "B",
                            "typeof": "reference"
                        },
                        "typeof": "binary"
                    },
                    "operator": 18,
                    "operatorStr": "OR",
                    "parens": true,
                    "right": {
                        "left": {
                            "left": {
                                "reference": "PeriodicalClassCode",
                                "typeof": "reference"
                            },
                            "operator": 7,
                            "operatorStr": "==",
                            "parens": false,
                            "right": {
                                "reference": "C",
                                "typeof": "reference"
                            },
                            "typeof": "binary"
                        },
                        "operator": 18,
                        "operatorStr": "OR",
                        "parens": false,
                        "right": {
                            "left": {
                                "reference": "PeriodicalClassCode",
                                "typeof": "reference"
                            },
                            "operator": 7,
                            "operatorStr": "==",
                            "parens": false,
                            "right": {
                                "reference": "D",
                                "typeof": "reference"
                            },
                            "typeof": "binary"
                        },
                        "typeof": "binary"
                    },
                    "typeof": "binary"
                },
                "typeof": "binary"
            }
        })
    }
}

function formatValue(typeOf: string, val: any) {
    switch (typeOf) {
        case "number":
            if (_.isInteger(+val)) {
                return {
                    "base": 10,
                    "typeof": ConditionExpression.typeOfKey[typeOf],
                    "isint": true,
                    "isfloat": false,
                    "int64": +val
                }
            } else {
                return {
                    "base": 10,
                    "typeof": ConditionExpression.typeOfKey[typeOf],
                    "isfloat": true,
                    "isint": false,
                    "float64": +val
                }
            }
        case "string":
            val = _.trim(val)
            val = val.slice(1)
            val = val.slice(0, val.length - 1)
            return {
                "typeof": typeOf,
                [ConditionExpression.typeOfKey[typeOf]]: val
            }
        case "bool":
            return {
                "typeof": typeOf,
                [ConditionExpression.typeOfKey[typeOf]]: val == "true" ? true : false,
            }

        default:
            break;
    }
    return {
        "typeof": typeOf,
        [ConditionExpression.typeOfKey[typeOf]]: val
    }
}
function getType(str: any) {

    if (isString(str)) {
        return "isString"
    }

    if (isBoolean(str)) {
        return "isBoolean"
    }
    if (isNumber(str)) {
        return "isNumber"
    }
    if (isReference(str)) {
        return "isReference"
    }
    if (isNull(str)) {
        return "isNull"
    }
    return "isIdentifier"
}


function isString(str: any) {
    if (!_.isString(str)) {
        return false
    }
    str = _.trim(str)
    const start = _.first(str)
    const end = _.last(str)
    return start == end && (start == "'" || start == "\"")
}

function isReference(str: any) {
    if (!_.isString(str)) {
        return false
    }
    if (/[a-zA-Z]+(\.[a-zA-Z]+)+/.test(str)) {
        return true
    }
    return false
}
function isBoolean(str: any) {
    str = _.trim(str)
    return str == "true" || str == "false"
}
function isNull(str: any) {
    str = _.trim(str)
    return str == "null"
}
function isNumber(str: any) {
    if (typeof str != "string") return false // we only process strings!  
    return !isNaN(str as any) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}
var j = {
    "left": {
        "left": {
            "reference": "IsOAaa",
            "typeof": "reference"
        },
        "operator": 7,
        "operatorStr": "==",
        "parens": false,
        "right": {
            "reference": "true",
            "typeof": "reference"
        },
        "typeof": "binary"
    },
    "operator": 17,
    "operatorStr": "AND",
    "parens": false,
    "right": {
        "left": {
            "left": {
                "reference": "PeriodicalClassCode",
                "typeof": "reference"
            },
            "operator": 7,
            "operatorStr": "==",
            "parens": false,
            "right": {
                "reference": "B",
                "typeof": "reference"
            },
            "typeof": "binary"
        },
        "operator": 18,
        "operatorStr": "OR",
        "parens": true,
        "right": {
            "left": {
                "reference": "PeriodicalClassCode",
                "typeof": "reference"
            },
            "operator": 7,
            "operatorStr": "==",
            "parens": false,
            "right": {
                "reference": "D",
                "typeof": "reference"
            },
            "typeof": "binary"
        },
        "typeof": "binary"
    },
    "typeof": "binary"
}
// [{"scope":"港澳台数据集","database":"thesis","roles":["own_role"],"conditions":{"accessType":"","id":"e5819936-bba2-4140-aa12-e3b0bc17208b","expressions":{"left":{"left":{"reference":"IsOAaa","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"true","typeof":"reference"},"typeof":"binary"},"operator":17,"operatorStr":"AND","parens":false,"right":{"left":{"left":{"left":{"reference":"PeriodicalClassCode","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"B","typeof":"reference"},"typeof":"binary"},"operator":18,"operatorStr":"OR","parens":true,"right":{"left":{"left":{"reference":"PeriodicalClassCode","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"C","typeof":"reference"},"typeof":"binary"},"operator":18,"operatorStr":"OR","parens":false,"right":{"left":{"left":{"reference":"PeriodicalClassCode","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"D","typeof":"reference"},"typeof":"binary"},"operator":17,"operatorStr":"AND","parens":false,"typeof":"binary","right":{"left":{"left":{"reference":"new insert","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"new insert","typeof":"reference"},"typeof":"binary"},"operator":17,"operatorStr":"OR","parens":false,"typeof":"binary","right":{"left":{"reference":"new inserta","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"new insert","typeof":"reference"},"typeof":"binary"}}},"typeof":"binary"},"typeof":"binary"},"operator":18,"operatorStr":"AND","parens":false,"right":{"left":{"reference":"IsOAa","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"true","typeof":"reference"},"typeof":"binary"},"typeof":"binary"},"typeof":"binary"}},"id":"37fb7089-5948-42dd-ab3d-caab624666c7","createAt":"2022-08-02T07:33:38.654Z","modifyAt":"2022-08-06T02:39:40.794Z","accessType":"SELECT"},{"scope":"港澳台数据集","database":"peridocal","roles":["own_role"],"conditions":{"accessType":"","id":"5eaaff42-3154-4db0-8596-79443746f658","expressions":{"left":{"left":{"reference":"IsOA","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"true","typeof":"reference"},"typeof":"binary"},"operator":17,"operatorStr":"AND","parens":false,"right":{"left":{"left":{"reference":"PeriodicalClassCode","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"B","typeof":"reference"},"typeof":"binary"},"operator":18,"operatorStr":"OR","parens":true,"right":{"left":{"left":{"reference":"PeriodicalClassCode","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"C","typeof":"reference"},"typeof":"binary"},"operator":18,"operatorStr":"OR","parens":false,"right":{"left":{"reference":"PeriodicalClassCode","typeof":"reference"},"operator":7,"operatorStr":"==","parens":false,"right":{"reference":"D","typeof":"reference"},"typeof":"binary"},"typeof":"binary"},"typeof":"binary"},"typeof":"binary"}},"id":"ad624d91-5bab-4d2d-bd3c-55553c52641c","createAt":"2022-08-02T07:39:30.312Z","modifyAt":"2022-08-03T02:15:52.795Z","accessType":"SELECT"}]

